export const HOME_ROUTE = () => '/';
export const GET_TOKEN_ROUTE = () => '/payment/:token';

export const GET_PAYMENT_STATUS_ROUTE = () => '/payment/result';
export const GET_NEW_PAYMENT_STATUS_ROUTE = () => '/return/final';
// La transaction s'est mal passée pour une erreur inconnue. A implémenter une vue d'erreur statique
export const ERROR_PAGE_ROUTE = () => '/payment/result/error';

export const SUCCESS_PAGE_ROUTE = () => '/payment/result/success';
export const FAIL_PAGE_ROUTE = () => '/payment/result/fail';

export const FORBIDDEN_ROUTE = () => '/forbidden';
export const CHECKOUT_ROUTE = '/payment/checkout';

export const GET_CS_OTP_RESULT = () => '/return/backotp';
